import { render, staticRenderFns } from "./DataOnFile.vue?vue&type=template&id=169cdee3&scoped=true"
import script from "./DataOnFile.vue?vue&type=script&lang=js"
export * from "./DataOnFile.vue?vue&type=script&lang=js"
import style0 from "./DataOnFile.vue?vue&type=style&index=0&id=169cdee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169cdee3",
  null
  
)

export default component.exports